<template>
  <accordion
    :title="title"
    :icon="icon"
    :active="componentList.length > 0"
    :start-open="false"
    classes="filter-accordion small mb-3"
  >
    <template slot="accordion-body">
      <div v-if="componentList.length !== 0" class="filters-active">
        <span>{{ 'Active filters' | translate }}</span>
        <b-button
          variant="outline-primary"
          class="btn-sm"
          @click.prevent="cleanFilter()"
        >
          <i class="fas fa-times" /> {{ 'Reset filter' | translate }}
        </b-button>
      </div>
      <b-alert
        class="alert-primary"
        v-for="row in componentList"
        :key="row.id"
        variant="filter"
        show
      >
        <span>{{ row.label | truncate(35) }}</span>
        <span class="close" @mousedown.prevent.stop="cleanFilter()">
          <i class="fas fa-times" :title="'Delete' | translate" />
        </span>
      </b-alert>
      <multiselect-thux
        label="label"
        attributetype="common filter select"
        :value="componentList[0]"
        :options="options"
        :placeholder="$t('Select an option')"
        :show-clean-button="false"
        @select="addFilter"
      />
    </template>
  </accordion>
</template>

<script>
import { mapGetters } from 'vuex'
import Accordion from '@/components/Accordion'
import MultiselectThux from '@/components/MultiselectThux'
import { CommonFilterTypes } from '@/pages/common-filters/store'

export default {
  name: 'TaskSelectFilter',
  components: {
    accordion: Accordion,
    'multiselect-thux': MultiselectThux
  },
  props: {
    title: { required: true, type: String },
    icon: { default: 'far fa-circle', type: String },
    options: { required: true, type: Array }
  },
  data () {
    return {
      componentList: []
    }
  },
  computed: {
    ...mapGetters({
      reset: CommonFilterTypes.COMMON_FILTERS.GETTERS.reset
    })
  },
  watch: {
    reset () {
      this.componentList = []
    }
  },
  methods: {
    addFilter (item) {
      this.componentList = [item]
      this.$emit('edit', [item.id])
    },
    cleanFilter () {
      this.componentList = []
      this.$emit('clean')
    }
  }
}
</script>
